import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
	enable: enableBodyScroll,
	disable: disableBodyScroll,
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/bodyScroll.js
// module id = 2
// module chunks = 0